module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/3/1-b2732cba820f4691c0ea306693ff9593.jpg";